import React, { useRef, useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator,
  TouchableOpacity
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { useTranslation } from 'react-i18next'
import Card from '../../shared/card/Card'
import CardSeparator from '../../shared/card/CardSeparator'
import Select from '../../shared/form/Select'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { useLabourStore } from '../../../stores/labour'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectKey, mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import ModalDrawer from '../../shared/modal/ModalDrawer'
import { Ionicons } from '@expo/vector-icons'
import Toast from 'react-native-toast-message'

type response = {
    success: boolean
    message: string
    error: string
}

const intialValues = {
    printName: ""
}

const WCRightsInformationForm = ({ navigation, route }): JSX.Element => {
    const formikRef = useRef(null)
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        essUserOnBoardingFormKey,
        mode
    } = params

    const { postWCRightsOnline, loading } = useFormsStore()
    const { initializeData } = useInitializeStore()
    const { labourData } = useLabourStore()
    const { personalData } = usePersonalStore()


    const w4schema = yup.object({
        printName: yup.string().required("Print Name is a required field")

    })





    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel={"Forms"}
                        navScreen="OnboardingForms"
                        title={'WC Rights And Duties Form For Karns'}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={w4schema}
                    onSubmit={async (values, actions) => {
                        const data = {
                            entityId: personalData.entityId,
                            essUserKey: initializeData.userkey,
                            essObKey: userId,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            completeOnline: mode === 'upload' ? false : true,
                            name: values?.printName
                        }

                        if (mode === 'upload') {
                            const w4Data: any = await postWCRightsOnline(data)
                            if (w4Data && w4Data?.success) {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: w4Data?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                            else {
                                await Toast.show({
                                    type: 'error',
                                    position: 'bottom',
                                    text1: w4Data?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60
                                })
                            }
                        } else {
                            navigation.navigate('WCRightsonline', {
                                userId,
                                essUserOnBoardingFormKey,
                                completeOnline: mode === 'upload' ? false : true,
                                values
                            })
                        }
                    }}
                >
                    {(props) => (
                        <>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Employee’s Printed Name *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.printName}
                                            onChangeText={(text) => {
                                                props.handleChange('printName')(text)
                                            }}
                                        />
                                        {props.touched.printName &&
                                            props.errors.printName && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.printName}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                            </Card>
                            {loading ? (
                                <ActivityIndicator />
                            ) : (
                                <View style={{ margin: 10 }}>
                                    <CustomButton
                                        text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                        onPress={props.handleSubmit}
                                    />
                                </View>
                            )}
                        </>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}
export default WCRightsInformationForm;
